export class ClaimModel {
	public amount: number;
	public retentionAmount?: number;
	public charge: string;
	public invoice?: string;
	public xeroLineItemId?: string;
	public lineId?: string; // quickbooks

	constructor(model?: Partial<ClaimModel>) {
		if (model) {
			Object.assign(this, model);
		}
	}
}
